import { Button } from "@/components/ui/button";
import { CheckCircle, Info } from "lucide-react";

interface Props {
  result: {
    message?: string;
    learning?: string;
    choice?: string;
    cash_impact?: number;
    event_id?: string;
  };
  onClose: () => void;
}

export default function ResultPopup({ result, onClose }: Props) {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="glass-card glow-border max-w-sm w-full p-6 space-y-4 animate-scale-in">
        <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto">
          <CheckCircle className="w-6 h-6 text-primary" />
        </div>

        {result.message && (
          <p className="text-sm text-foreground text-center font-semibold">{result.message}</p>
        )}

        {result.learning && (
          <div className="bg-muted/30 rounded-lg p-3 flex items-start gap-2">
            <Info className="w-4 h-4 text-accent shrink-0 mt-0.5" />
            <p className="text-xs text-muted-foreground leading-relaxed">{result.learning}</p>
          </div>
        )}

        <Button onClick={onClose} className="w-full">Continue</Button>
      </div>
    </div>
  );
}
